import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IAcademicStructurePayload, IInitialStateStructure, IStructureSettingsPayload} from "../types";
import {GetAcademicStructure} from "./thunk";



const initialState:IInitialStateStructure = {
    academicStructure: [],
    filterStructure:[],
    structureSettings:[],
    isLoadingStructure:false,
    selectedStructureIDs:[],
    academicStructureRestore:[],
    isViewStructure:false,
}

const academicStructureSlice = createSlice({
    name:"academicStructure",
    initialState,
    reducers:{
        setAcademicStructure: (state, action:PayloadAction<{data:IAcademicStructurePayload[],defaultLanguage:string}> )=>{
            const {defaultLanguage,data} = action.payload;
            state.academicStructure = data;
            state.filterStructure = data.flatMap(
                (data) =>
                    data.translations
                        .filter((elem) => elem.slug === defaultLanguage && elem.name)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name as string,

                        }))
            );
        },
        setSelectedStructureIDs: (state, action) => {
            state.selectedStructureIDs=action.payload
        },
        deletedStructure:(state,action: PayloadAction<number>) => {
            state.academicStructure = state.academicStructure.filter((elem)=>elem.id !== action.payload)
        },
        setIsViewStructureRestore:(state)=>{
            state.isViewStructure =!state.isViewStructure;
        },
        deletedRestoreStructure:(state,action)=>{
            state.academicStructureRestore = state.academicStructureRestore.filter(
                (elem) => elem.id !== action.payload
            );
        },
        setStructureRestoreData:(state, action) => {
            state.academicStructureRestore = action.payload;
        },
        updateStructure: (state, action: PayloadAction<IAcademicStructurePayload>) => {
            const updateData = action.payload;

            state.academicStructure = state.academicStructure.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData
                    };
                }
                return elem;
            });
        },
        setStructureSettings:(state, action: PayloadAction<IStructureSettingsPayload[]>)=>{
            state.structureSettings=action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAcademicStructure.pending, (state) => {
                state.isLoadingStructure = true;
            })
            .addCase(GetAcademicStructure.fulfilled, (state) => {
                state.isLoadingStructure = false;
            })
            .addCase(GetAcademicStructure.rejected, (state) => {
                state.isLoadingStructure = false;
            });
    },
})
export const{
    setAcademicStructure,
    setSelectedStructureIDs,
    deletedStructure,
    updateStructure,
    setIsViewStructureRestore,
    deletedRestoreStructure,
    setStructureRestoreData,
    setStructureSettings
} =academicStructureSlice.actions;

export default academicStructureSlice